import React, { FC, useEffect, useState } from 'react';
import { ClipboardIcon, ShareIcon } from '@heroicons/react/24/outline';
import { XMarkIcon as CloseIcon } from '@heroicons/react/24/solid';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
  FacebookIcon,
  WhatsappIcon,
  TwitterIcon,
  LinkedinIcon,
  EmailIcon,
} from 'react-share';
import { PROJECT_SHARED } from 'helpers/constants/events';
import { useAccount } from 'frontastic';

const ShareProjectPopup: FC<any> = ({ shareLink, show, onClose }) => {
  const [copySuccess, setCopySuccess] = useState(false);
  const {account} = useAccount();

  const handleCopy = () => {
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
    if (typeof window === "undefined") return;
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event: PROJECT_SHARED,
      userId: account?.accountId,
      projectUrl: shareLink,
      platform: 'copy',
    });
  };
    const handleSocialShare = (platform:string)=> {
    if (typeof window === "undefined") return;
    if(platform === 'Email'){
      window.location.href = encodeURI(`mailto:
        ?subject=Share Link
        &body=Link: ${shareLink}`);  
    }
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event: PROJECT_SHARED,
      projectUrl: shareLink,
      userId: account?.accountId,
      platform
    });
  };
  return (
    <div>
      {show && (
        <div
          className="shadow fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[60]"
          tabIndex={-1}
          style={{
            backgroundColor: 'rgba(0,0,0,0.4)',
            backdropFilter: 'blur(4px)',
          }}
        >
          <div className="max-w-[500px] bg-white rounded py-[18px]">
            <div className="">
              <div className="flex items-center justify-between px-[18px] pb-[18px] border-b">
                <div className="flex align-items-center">
                  <ShareIcon className="w-18" />
                  <h5 className="mb-0" style={{ fontWeight: '400', marginLeft: '8px' }}>
                    Share link
                  </h5>
                </div>

                <div onClick={onClose} style={{ cursor: 'pointer' }}>
                  <CloseIcon className="w-20" />
                </div>
              </div>

              <div className="px-[18px] pt-[18px]">
                <div className="relative block copy-share-link w-full truncate rounded-full bg-gray-200 py-8 pl-16 pr-33">
                  {shareLink}
                  <div className="absolute clipboard-copy">
                    <CopyToClipboard text={shareLink} onCopy={handleCopy}>
                      <ClipboardIcon className="w-20" />
                    </CopyToClipboard>
                  </div>
                </div>

                {copySuccess && (
                  <div className="text-green-500" style={{ fontSize: '12px', paddingLeft: '8px', paddingTop: '4px' }}>
                    Link copied to clipboard!
                  </div>
                )}
                <div>
                  <div>
                    <h5 className="mt-16" style={{ fontWeight: '400' }}>
                      Share using:
                    </h5>
                    <div className="flex mt-12 gap-2">
                      <FacebookShareButton url={shareLink} onClick={()=>handleSocialShare('facebook')}>
                        <FacebookIcon size={40} round={true} />
                      </FacebookShareButton>

                      <WhatsappShareButton url={shareLink} onClick={()=>handleSocialShare('Whatsapp')}>
                        <WhatsappIcon size={40} round={true} />
                      </WhatsappShareButton>

                      <TwitterShareButton url={shareLink} onClick={()=>handleSocialShare('Twitter')}>
                        <TwitterIcon size={40} round={true} />
                      </TwitterShareButton>

                      <LinkedinShareButton url={shareLink} onClick={()=>handleSocialShare('Linkedin')}>
                        <LinkedinIcon size={40} round={true} />
                      </LinkedinShareButton>

                      <EmailShareButton url={shareLink} onClick={()=>handleSocialShare('Email')}>
                        <EmailIcon size={40} round={true} />
                      </EmailShareButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShareProjectPopup;
